
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/latest_photos/[index]",
      function () {
        return require("private-next-pages/inspiration/latest_photos/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/latest_photos/[index]"])
      });
    }
  